<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Advance Bookings
        </h4>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Booking info</th>
              <th scope="col">Package Title</th>
              <th scope="col">Package type</th>
              <th scope="col">User Email</th>
              <th scope="col">User Phone</th>
              <th>Total asset used</th>
              <th scope="col">Start date</th>
              <th scope="col">End date</th>
              <th scope="col">Chargeable Amount</th>
              <th scope="col">Pending payment amount</th>
              <th scope="col">Status</th>

              <th scope="col">Created At</th>
              <!-- <th scope="col">Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let booking of bookings">
              <td>{{ booking?.booking_info ? booking.booking_info : "-" }}</td>
              <td>{{ booking.package_id?.title | titlecase }}</td>
              <td>{{ booking?.package_type.replace("_", " ") | titlecase }}</td>
              <td>{{ booking?.user_id?.email }}</td>
              <td>{{ booking?.user_id?.mobile }}</td>

              <td>
                {{
                  booking.total_asset_used > 0 ? booking.total_asset_used : "-"
                }}
              </td>

              <td>{{ booking?.start_date | date : "medium" }}</td>
              <td>{{ booking?.end_date | date : "medium" }}</td>
              <td>
                {{ booking?.chargeableAmount ? currency : "" }}
                {{
                  booking?.chargeableAmount
                    ? booking.chargeableAmount / 100
                    : "-"
                }}
              </td>
              <td>
                {{ booking.pending_payment_amount > 0 ? currency : "" }}
                {{
                  booking.pending_payment_amount > 0
                    ? booking.pending_payment_amount / 100
                    : "-"
                }}
              </td>
              <td>
                <span
                  [class]="'badge badge-' + getStatusClass(booking.status)"
                  class="rounded-pill px-3"
                  style="font-size: 100%"
                >
                  {{ booking.status | titlecase }}
                </span>
              </td>

              <td>{{ booking.created_at | date : "medium" }}</td>
            </tr>
            <tr *ngIf="bookings.length == 0">
              <td colspan="8">No bookings found</td>
            </tr>
          </tbody>
        </table>

        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="bookings.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalcount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
